import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const colourModURL = "api/v1/products-app/colour";

//obtaining the paginated data
export const getColour = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${colourModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllColour = () => axiosInstance.get(`${colourModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageColour = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${colourModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createColour = (body) => axiosInstance.post(`${colourModURL}/create`, body);
//updating function
export const updateColour = (id, body) => axiosInstance.patch(`${colourModURL}/update/${id}`, body);

//searching function
export const handleSearch = (rowsPerPage, search, sortOrder) =>
  axiosInstance.get(`${colourModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`);

// checking the redundant data
export const checkRedundantDataColourName = (e, cancelToken) =>
  axiosInstance.get(`${colourModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
